/**
 * SxaAssessmentNarrowTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// Sxa Components
import SxaQuestionInputDynamicBandTile from "./SxaQuestionInputDynamicBandTile";
import SxaAssessmentPortraitNavTile from "./SxaAssessmentPortraitNavTile";

/*
from PD, D text headers:
fontWeight: 'bold',
borderBottom: '0.1em solid lightgrey',

from root div:
minHeight: 360
 */

class SxaAssessmentNarrowTile extends React.Component {
    constructor(props) {
        super(props);

        //console.log("A-Narrow: ass.currentQuestion = " + props.ass.currentQuestion.oid);

        // Assign current Q ref to state for refresh
        this.state = { currq: props.ass.currentQuestion };
    }

    // Callback function used by children to signal Q change (e.g. nav back or next, PA or D select)
    handleQChange = (q) => {
        // Check for Q already set
        var currQ = this.state.currq;
        if (currQ.oid === q.oid) {
            //console.log("A-Narrow.handleQChange(): current Question was NOT changed; Q = " + q.oid);

            // Update nav buttons
            this.nav.changeQuestion(q);

            return;
        }

        //console.log("Assessment current Question was changed; new Q = " + q.oid);

        // Trigger re-render
        this.setState(state => ({currq: q}));

        // Re-bind the Q-Input tile
        this.qin.changeQuestion(q);

        // Update nav buttons
        this.nav.changeQuestion(q);

        // Update the header X of Y - signal up to Portrait tile
        this.props.signalQChange(q);
    }

    // Callback function used by child to signal Q-score change
    handleScoreChange = () => {
        //console.log("Assessment_Input.handleScoreChange()");

        // Signal the Assessment_Root container - callback function
        this.props.signalScoreChange();
    };

    // Callback function used by child Nav tile to signal Finish
    handleFinish = () => {
        //console.log("Assessment was finished");

        // Signal to Portrait container to show Finish tile
        this.props.signalFinish();
    }

    // Callback function used by parent tile to signal A completed
    handleCompleted = () => {
        //console.log("Assessment was completed");

        // Signal to Nav container to update buttons
        this.nav.handleCompleted();
    }

    render() {
        return (
            <React.Fragment>
                {this.props.ass ? (
                    <div style={{ padding: 0 }}>
                        <Grid container spacing={0} style={{padding: 0}}
                              direction="row" justify="space-between" alignItems="stretch">
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center" style={{background: "white"}}>
                                <Typography color="inherit" style={{ fontSize: 18,
                                    fontFamily: 'Open Sans, sans-serif',
                                    color: "#1e2b56",
                                    borderBottom: '0.075em solid #627792',
                                    padding: '0.5em',
                                    paddingTop: '0.5em',
                                    paddingBottom: '0.5em',
                                    marginLeft: '1.0em', marginRight: '1.0em'}}
                                >
                                    {this.state.currq.paName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center" style={{background: "white"}}>
                                <Typography color="inherit" style={{ fontSize: 18,
                                    fontFamily: 'Open Sans, sans-serif',
                                    color: "#517992",
                                    padding: '0.5em',
                                    paddingTop: '0.5em',
                                    paddingBottom: '0.1em',
                                    marginLeft: '1.0em', marginRight: '1.0em'}}>
                                    {this.state.currq.dName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <SxaQuestionInputDynamicBandTile q={this.state.currq}
                                                                 ref={(qin) => { this.qin = qin; }}
                                                                 handleScoreChange={this.handleScoreChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12} xl={12} align="center">
                                <SxaAssessmentPortraitNavTile q={this.state.currq}
                                                      ref={(nav) => { this.nav = nav; }}
                                                      handleQChange={this.handleQChange}
                                                              handleFinish={this.handleFinish}
                                />
                            </Grid>
                        </Grid>
                    </div>
                ) : "No Assessment found"}
            </React.Fragment>
        )
    }
}

export default SxaAssessmentNarrowTile;